import Udesk from 'Udesk';
import Template from './template.tsx';
import React from 'react';

class Component extends React.Component {
    render() {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(Component);
